<template lang="pug">
md-theme(md-name="default")
  md-card#card-item
    // Media
    md-card-media
      // Video
      video.video-class(
        v-if="lightUpVideo",
        :src="getVideoSource(item)",
        :type="getVideoType(item)",
        autoplay,
        controls
      )
      // Image placeholder
      md-layout(v-else)
        md-button#btn-play-item-card.overlay-play.md-primary.md-raised.play(
          @click="lightUpVideo = !lightUpVideo",
          md-theme="blue"
        )
          md-icon(md-iconset="fa fa-play-circle")
          span PLAY
        img.card__img(
          :src="getVideoPoster(item)",
          :alt="item.name",
          :width="250",
          :height="200"
        )
    // Header
    md-card-header
      .card__header {{ mediumTitle(item) }}
      .md-subtitle {{ item.credit || item.account.name }}
      .md-subhead {{ formattedDate(item.lastUpdated) }}
      .md-subhead {{ secondsToHms(item.duration) }}
    // Actions and expanded content
    md-card-expand
      // Actions
      md-card-actions
        p.priceStyle {{ this.pricing }}
        span(style="flex: 1")
        transition(
          name="bounce",
          enter-active-class="animated bounceIn",
          leave-active-class="animated bounceOut",
          mode="out-in"
        )
          md-spinner.md-warn.card-action-spinner(
            md-indeterminate,
            :md-size="25",
            v-if="addingOrRemovingFromPlaylist"
          )
          md-button#btn-add-item-card.md-icon-button.md-accent(
            @click="addPlaylistItem",
            v-if="!itemInPlaylist && !addingOrRemovingFromPlaylist"
          )
            md-icon(md-iconset="fa fa-plus-circle")
          md-button#btn-remove-item-card.md-icon-button.md-warn(
            @click="removePlaylistItem",
            v-if="itemInPlaylist && !addingOrRemovingFromPlaylist"
          )
            md-icon(md-iconset="fa fa-trash-alt")
        md-button.md-icon-button(md-expand-trigger)
          md-icon(md-iconset="fa fa-chevron-down")
      // Content
      md-card-content
        span.md-subheading {{ networkName(item) }}
        .card__text(v-html="item.description")
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import videoMixin from "../../shared-components/videomixins";

export default {
  mixins: [videoMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      addingOrRemovingFromPlaylist: false,
      lightUpVideo: false,
    };
  },
  computed: {
    ...mapState({
      userAccount: (state) => state.user.useraccount,
    }),
    ...mapGetters("playlist", ["itemIds"]),

    itemInPlaylist() {
      return this.itemIds.includes(this.item._id);
    },
    pricing() {
      let unit = "CPM";
      let price = 0;
      const currentAccount = localStorage.getItem("impersonate")
        ? localStorage.getItem("impersonate")
        : this.userAccount._id;
      if (currentAccount !== this.item.account) {
        if (this.item.licenses.length > 0) {
          unit = this.item.licenses[0].pricing[0].unit;
          this.item.licenses.map((license) => {
            price += license.pricing[0].price * 1.3;
          });
        }
        return `$${price.toFixed(2)}/${unit}`;
      }
      return "OWNER";
    },
  },
  methods: {
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: "bottom-left",
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    },

    ...mapActions("playlist", ["addItemAt", "removeItem"]),

    addPlaylistItem() {
      this.addingOrRemovingFromPlaylist = true;
      this.addItemAt({ item: this.item, index: 0 })
        .then(() => {
          this.addingOrRemovingFromPlaylist = false;
          this.showAlertToast("Playlist Saved", "success");
        })
        .catch(() => {
          this.addingOrRemovingFromPlaylist = false;
          this.showAlertToast("Something wrong!", "error");
          this.$emit("addToPlaylistError", {
            msg: "Error while adding the item to the playlist. Please try again later.",
          });
        });
    },
    removePlaylistItem() {
      this.addingOrRemovingFromPlaylist = true;
      this.removeItem(this.item._id)
        .then(() => {
          this.addingOrRemovingFromPlaylist = false;
          this.showAlertToast("Playlist Saved", "success");
        })
        .catch(() => {
          this.addingOrRemovingFromPlaylist = false;
          this.showAlertToast("Something wrong!", "error");
          this.$emit("removeFromPlaylistError", {
            msg: "Error while removing the item from the playlist. Please try again later.",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-media {
  background-color: rgb(0, 0, 0);
  height: 18rem;
  .overlay-play {
    position: absolute;
    z-index: 100;
    bottom: 0;
    right: 0;
  }
}

.md-card {
  border-radius: 0.5rem;
  flex: 1;
}
.md-card:hover {
  transform: translateY(-0.5%);
  transition: all 200ms ease;
  box-shadow: 0 4rem 8rem rgba(0, 0, 0, 0.2);
}
.card-action-spinner {
  padding: 8px;
  margin-right: 16px;
}
.card__header {
  font-size: 1.3rem;
  font-weight: 500;
  max-width: 450px;
  margin-bottom: 1.5rem;
}
.card__text {
  letter-spacing: 0.1rem;
  line-height: 1.7;
  margin-bottom: 2.5rem;
}
.card__img {
  display: block;
  width: 100%;
  height: 18rem;
  object-fit: contain;
  background-color: rgb(0, 0, 0);
}
.play {
  border-radius: 5rem;
}
.video-class {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.priceStyle {
  margin-left: 10px;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/MediaItem.vue